import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-multiple-input-search',
    templateUrl: './multiple-input-search.component.html',
    styleUrls: ['./multiple-input-search.component.less'],
})
export class MultipleInputSearchComponent implements OnInit {
    @Input() placeholder = 'Search...';
    @Input() color = 'blue';
    @Output() searchTag = new EventEmitter();
    tags: string[] = [];
    splitStr = ';';
    keyword = '';
    timer: number | null = null;

    constructor() {
    }

    ngOnInit(): void {
    }

    onClose(index: number): void {
        this.tags.splice(index, 1);
    }

    enterSearch(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            this.search();
        }
    }

    search(): void {
        this.getTags();
        this.searchTag.emit(this.tags);
    }

    getTags(): string[] {
        if (this.keyword) {
            this.tags = [...this.tags, this.keyword];
            this.keyword = '';
        }
        return this.tags;
    }

    changeKeyword(): void {
        if (this.keyword.indexOf(this.splitStr) !== -1) {
            const tag = this.keyword.slice(0, this.keyword.length - 1);
            this.tags = [...this.tags, tag];
            this.keyword = '';
        }
    }

    reset(): void {
        this.tags = [];
        this.keyword = '';
    }
}
